module.exports = __webpack_public_path__ + "static/xiao-cc9b0df85faacdb9f780eeb982408778.png";